<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Lezen basis | Instructiemodus" [steps]="0" />

  <rid-mechanic-content>
    <rid-mechanic-title [title]="instruction()" />

    @for (input of [word()]; track input) {
      <div class="relative flex flex-col place-items-center gap-4">
        @if (state() === 'DONE' || state() === 'EVALUATING') {
          <rid-audio-button
            class="absolute -top-8 -translate-y-[100%]"
            [src]="input.audio"
            size="SMALL"
            animate.enter="anim-pop-in"
            (click)="evaluate()"
          />
        }
        <div class="relative">
          @if (showCountdown()) {
            <rid-reading-countdown #countdown />
          }
          <rid-segmented-word-card
            #card
            [segments]="input.word"
            mode="READING"
            animate.enter="anim-pop-in"
            (mouseenter)="state() === 'EVALUATING' ? card.decompress() : undefined"
            (mouseleave)="state() === 'EVALUATING' ? card.compress() : undefined"
          />
        </div>
      </div>
    }

    @if (state() === 'DONE' || state() === 'EVALUATING') {
      <rid-bottom-button content="Volgende" (clicked)="next()" />
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
